export default {
      id: "2-1-2-usage",
      viewBox: "0 0 180 180",
      url: "assets/" + "sprite.svg#2-1-2-usage",
      toString: function () {
        return this.url;
      }
    }